module.exports = __webpack_public_path__ + "static/media/ajax-Loader.2c9db73f.gif";